import React from "react";
import TratazHomeLandingPage from "demos/TratazHomeLandingPage.js";

export default () => {
  return <TratazHomeLandingPage />;
};
